export interface IPrechargedServiceFare {
	id: number;
	travelFrom: string;
	travelTo: string;
	bookingFrom: string;
	bookingTo: string;
	priceSingle?: number;
	priceDbl?: number;
	priceTpl?: number;
	priceCpl?: number;
	priceChild?: number;
}

export interface IPrechargedService {
	id: number;
	name: string;
	destinationCodes: string[];
	observations?: string;
	enable: boolean;
	serviceType: number;
	options?: number[];
	fares?: IPrechargedServiceFare[];
	forAllDestinations: boolean;
	lastUpdate: string;
	provider?: string; // Campo futuro preparado
	availableInQuotation?: boolean; // Nuevo campo - disponible en cotizador
	internalNotes?: string; // Nuevo campo - notas internas
	// Para compatibilidad con la tabla (campos derivados)
	destinations?: string[];
	serviceTypeName?: string;
}

export interface IPrechargedServiceResponse {
	data: IPrechargedService[];
}

export interface IPrechargedServiceListResponse {
	data: IPrechargedService[];
	// Headers para paginación
	page: number;
	pageTotal: number;
	size: number;
	total: number;
}

export interface ICity {
	id: number;
	name: string;
	code: string;
	countryName?: string;
	countryCode?: string;
	// Agregar otros campos que pueda tener la respuesta de ciudades
}

export interface ICitiesResponse {
	data: ICity[];
}

export interface IPrechargedServiceFilters {
	destinationCodes?: string;
	name?: string;
	serviceTypeName?: string;
	enable?: boolean;
	observations?: string;
	lastUpdate?: string;
	forAllDestinations?: boolean;
	availableInQuotation?: boolean;
}

// Interfaces para tipos de servicios
export interface IServiceType {
	id: number;
	name: string;
}

export interface IServiceTypesResponse {
	data: IServiceType[];
}

// Mapeo de opciones de servicios (según la captura del usuario)
export const SERVICE_OPTIONS_MAP: Record<number, string> = {
	1: 'Común',
	2: 'Llegada',
	3: 'Salida',
	4: 'Ida',
	5: 'Vuelta',
};

// Helpers para resolver nombres
export const getServiceTypeName = (serviceTypes: IServiceType[], id: number): string => {
	const serviceType = serviceTypes.find((type) => type.id === id);
	return serviceType ? serviceType.name : `Tipo ${id}`;
};

export const getServiceOptionName = (id: number): string => {
	return SERVICE_OPTIONS_MAP[id] || `Opción ${id}`;
};
